"use client";
import useProfileCheck from "../hooks/useProfileCheck";
import ProfileCompletionModal from "./ProfileCompletionModal";

export default function GlobalProfileCompletionModal() {
  const { showProfileModal, handleProfileComplete, handleClose } = useProfileCheck();

  return (
    <ProfileCompletionModal
      show={showProfileModal}
      onClose={handleClose}
      onProfileComplete={handleProfileComplete}
    />
  );
} 